import React from 'react';
import { Box, Typography } from '@mui/material';
import { DS } from '../PatientForms/designTokens';

interface FormTextInputProps {
  id?: string;
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  type?: 'text' | 'number';
  labelFontWeight?: number;
  labelFontSize?: string;
}

const FormTextInput: React.FC<FormTextInputProps> = ({
  id,
  label,
  value,
  onChange,
  onBlur,
  type = 'text',
  labelFontWeight = 600,
  labelFontSize = '16px',
}) => (
  <Box id={id} sx={{ mb: 2 }}>
    <Typography
      component="label"
      sx={{
        display: 'block',
        fontSize: labelFontSize,
        fontWeight: labelFontWeight,
        color: '#374151',
        mb: 0.5,
        fontFamily: DS.fontBody,
      }}
    >
      {label}
    </Typography>
    <input
      type={type}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      style={{
        width: '100%',
        padding: '10px 12px',
        border: '1px solid #D1D5DB',
        borderRadius: '8px',
        fontSize: '16px',
        fontFamily: DS.fontBody,
        outline: 'none',
        boxSizing: 'border-box',
        transition: 'border-color 0.15s',
      }}
      onFocus={(e) => {
        const { style } = e.currentTarget;
        style.borderColor = DS.deepTeal;
        style.boxShadow = `0 0 0 2px ${DS.deepTeal}33`;
      }}
      onBlurCapture={(e) => {
        const { style } = e.currentTarget;
        style.borderColor = '#D1D5DB';
        style.boxShadow = 'none';
      }}
    />
  </Box>
);

export default FormTextInput;
